import { useEffect } from 'react';

/**
 * Q36 — Lock auth/onboarding pages to ASAP light theme.
 *
 * Some users have their device in Dark Mode (iOS/Android sunset auto-switch).
 * Without intervention the app's bootstrap script in index.html applies
 * `html.dark` to first-time visitors, which makes the lime CTA + light input
 * fields completely unreadable.
 *
 * This component removes the dark class while mounted and restores the prior
 * theme on unmount — so the rest of the app keeps user's theme preference.
 *
 *   Usage: place at the top of Login/Register/Onboarding pages.
 *           <ThemeLock /> (no props)
 */
export default function ThemeLock() {
  useEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains('dark');
    const prevColorScheme = root.style.colorScheme;
    // Force light for this screen
    if (hadDark) root.classList.remove('dark');
    root.style.colorScheme = 'light';
    root.setAttribute('data-theme-locked', 'light');

    return () => {
      // Restore previous theme so the rest of the app behaves normally.
      if (hadDark) root.classList.add('dark');
      root.style.colorScheme = prevColorScheme || '';
      root.removeAttribute('data-theme-locked');
    };
  }, []);
  return null;
}
